import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useNavigate, useLocation } from 'react-router-dom';
import HomeScreen         from './components/HomeScreen';
import ResultsDashboard   from './components/ResultsDashboard';
import AdminPanel         from './components/AdminPanel';
import VoterRegistration  from './components/VoterRegistration';

export const API_BASE = process.env.REACT_APP_API_URL || '';

// ── Shared TN EC site header (rendered on every page) ─────────────────────────
export function TNECHeader() {
  const navigate = useNavigate();
  const location = useLocation();
  const path     = location.pathname;

  const navItem = (label, to) => (
    <li key={to}>
      <button
        className={path === to ? 'active' : ''}
        onClick={() => navigate(to)}
      >
        {label}
      </button>
    </li>
  );

  return (
    <header className="tnec-header">
      <div className="tnec-header-top">
        <span>தமிழ்நாடு அரசு — Government of Tamil Nadu</span>
        <span>Election Commission of India | தேர்தல் ஆணையம்</span>
      </div>

      <div className="tnec-header-main">
        <div className="tnec-emblem" title="Tamil Nadu State Emblem">🏛️</div>
        <div className="tnec-titles">
          <div className="tnec-title-tamil">தமிழ்நாடு தேர்தல் ஆணையம்</div>
          <div className="tnec-title-en">Tamil Nadu Election Commission</div>
          <div className="tnec-title-sub">Secure Biometric Voting System • 2026 General Election</div>
        </div>
        <div className="tnec-header-right">
          <div>Helpline: 1950</div>
          <div>voting.tnec.tn.gov.in</div>
        </div>
      </div>

      <div className="tnec-accent-bar" />

      <nav className="tnec-nav">
        <ul>
          {navItem('Home', '/')}
          {navItem('Live Results', '/results')}
          {navItem('Voter Registration', '/register')}
          {navItem('Admin', '/admin')}
        </ul>
      </nav>
    </header>
  );
}

// ── TN EC Footer ───────────────────────────────────────────────────────────────
export function TNECFooter() {
  return (
    <footer className="tnec-footer">
      <div>© 2026 Tamil Nadu Election Commission | All rights reserved</div>
      <div>
        Powered by Blockchain-Secured Biometric Technology &nbsp;•&nbsp;
        Helpline: <strong style={{color:'rgba(255,255,255,0.8)'}}>1950</strong> &nbsp;•&nbsp;
        <a href="#top">Back to Top</a>
      </div>
    </footer>
  );
}

// ── App with header/footer on every route ─────────────────────────────────────
function Layout({ children }) {
  return (
    <>
      <TNECHeader />
      {children}
      <TNECFooter />
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/"         element={<HomeScreen />} />
          <Route path="/results"  element={<ResultsDashboard />} />
          <Route path="/register" element={<VoterRegistration />} />
          <Route path="/admin"    element={<AdminPanel />} />
          <Route path="*"         element={<Navigate to="/" replace />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}
